// src/telegram/linkAccount.js
import api from "../../api/axios";

/**
 * Если сайт открыт внутри Telegram WebApp,
 * отправляет initData в ваш бекенд.
 */
export async function linkTelegramAccount() {
  const tg = window.Telegram?.WebApp;
  if (!tg?.initData) {
    return;
  }
  try {
    await api.post(
      "/accounts/telegram-link/",
      tg.initData,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );
  } catch (err) {
  }
}